module.exports = __webpack_public_path__ + "img/安全产品示例图_5.ea1e9563.png";